export default function EPYCExplorerLogo() {
  return (
    <svg viewBox="0 0 344 35" fill="none">
      <path
        d="M343.314 0.0817871H169.475V33.9897H343.314V0.0817871Z"
        fill="#6A6B6D"
      />
      <path
        d="M34.6165 0.0908203H0.786621V6.89785H34.6165V0.0908203Z"
        fill="#5C4FBA"
      />
      <path
        d="M0.795654 13.7231L0.80469 34.1624L34.6346 34.1351V27.3281L7.57247 27.3463L7.56344 20.5302L34.6255 20.512V13.705L0.795654 13.7231Z"
        fill="#5C4FBA"
      />
      <path
        d="M111.936 0.0272217L102.249 13.5413L92.5539 0.045398H84.1868L98.8337 20.4665L98.8428 34.0987L105.611 34.0896L105.602 20.4665L120.294 0.0272217H111.936Z"
        fill="#5C4FBA"
      />
      <path
        d="M126.519 27.2645C126.519 31.027 129.555 34.0806 133.296 34.0715L160.394 34.0533V27.2372L133.775 27.2554C133.513 27.2554 133.296 27.0373 133.296 26.7737V7.31597C133.287 7.05241 133.495 6.83429 133.766 6.83429L160.385 6.81612V0L133.287 0.0181763C129.546 0.0181763 126.51 3.0718 126.519 6.83429V27.2554V27.2645Z"
        fill="#5C4FBA"
      />
      <path
        d="M72.3409 0.0545654L45.2607 0.0727417V6.87977L71.862 6.86159C72.1241 6.86159 72.3409 7.07971 72.3409 7.34327V13.1869C72.3409 13.4505 72.1331 13.6686 71.862 13.6686L45.2607 13.6868V34.117H52.0466V20.4938L72.3499 20.4847C76.0908 20.4847 79.1177 17.4311 79.1177 13.6686V6.86159C79.1177 3.0991 76.0727 0.0545654 72.3409 0.0545654Z"
        fill="#5C4FBA"
      />
      <path
        d="M177.165 28.5459L177.146 5.55286H191.242V10.1333H182.188V14.3502H190.528V18.9397H182.188V23.9473H191.242V28.5368H177.146L177.165 28.5459Z"
        fill="white"
      />
      <path
        d="M206.73 16.8585L213.534 28.5277H208.248L203.901 20.9391L199.564 28.5368H194.278L201.037 16.8676L194.504 5.54376H199.79L203.901 12.787L208.004 5.53467H213.29L206.739 16.8585H206.73Z"
        fill="white"
      />
      <path
        d="M225.949 21.5389H222.117V28.5186H217.075L217.057 5.52554H226.211C231.659 5.51645 233.683 7.72487 233.683 12.0417V15.0499C233.683 19.3668 231.406 21.5389 225.949 21.548V21.5389ZM228.632 12.5325C228.632 10.8785 228.063 10.1151 225.94 10.1151H222.108V17.0584H225.94C228.162 17.0584 228.632 16.1859 228.632 14.5319V12.5325Z"
        fill="white"
      />
      <path
        d="M237.388 28.5095L237.37 5.51648H242.412L242.421 23.92H251.303V28.5095H237.379H237.388Z"
        fill="white"
      />
      <path
        d="M271.697 21.7934C271.697 25.2832 269.347 28.8367 263.022 28.8458C256.697 28.8458 254.339 25.2923 254.339 21.8025V12.2054C254.339 8.71551 256.679 5.16204 263.004 5.15295C269.329 5.15295 271.688 8.70642 271.688 12.1872V21.7843L271.697 21.7934ZM266.646 12.6416C266.646 10.8421 265.534 9.74247 263.013 9.74247C260.492 9.74247 259.381 10.8512 259.381 12.6416V21.339C259.381 23.1384 260.501 24.2381 263.022 24.2381C265.543 24.2381 266.655 23.1293 266.655 21.3299V12.6325L266.646 12.6416Z"
        fill="white"
      />
      <path
        d="M284.247 21.3298H281.284V28.4822H276.242L276.224 5.48916H285.539C290.988 5.48008 293.012 7.6885 293.012 12.0054V14.8409C293.012 17.7036 292.009 19.6394 289.759 20.6119L295.181 28.4822H289.19L284.238 21.3389L284.247 21.3298ZM287.979 12.487C287.979 10.7603 287.338 10.0696 285.286 10.0696H281.284V16.8403H285.286C287.437 16.8403 287.979 16.0405 287.979 14.3138V12.487Z"
        fill="white"
      />
      <path
        d="M298.551 28.4731L298.533 5.4801H312.629V10.0605H303.575V14.2774H311.915V18.867H303.575V23.8745H312.629V28.464H298.533L298.551 28.4731Z"
        fill="white"
      />
      <path
        d="M325.197 21.3026H322.234V28.455H317.192L317.174 5.46194H326.489C331.938 5.45285 333.962 7.66128 333.962 11.9781V14.8137C333.962 17.6764 332.959 19.6122 330.709 20.5846L336.131 28.455H330.14L325.188 21.3117L325.197 21.3026ZM328.92 12.4598C328.92 10.7331 328.279 10.0424 326.227 10.0424H322.225V16.813H326.227C328.378 16.813 328.92 16.0133 328.92 14.2865V12.4598Z"
        fill="white"
      />
    </svg>
  );
}
